var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container content-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-8 offset-sm-2" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.our_service.title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("h3", { staticClass: "service-title" }, [
              _vm._v(_vm._s(_vm.$t("message.our_service.bedroom_title")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "maininfo-list" }, [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bedroom01")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bedroom02")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bedroom03")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bedroom04")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bedroom05")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("h3", { staticClass: "service-title" }, [
              _vm._v(_vm._s(_vm.$t("message.our_service.bathroom_title")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "maininfo-list" }, [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom01")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom02")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom03")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom04")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom05")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.bathroom06")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("h3", { staticClass: "service-title" }, [
              _vm._v(_vm._s(_vm.$t("message.our_service.kitchen_title")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "maininfo-list" }, [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen01")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen02")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen03")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen04")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen05")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.our_service.kitchen06")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("span", { staticClass: "text-danger" }, [
          _vm._v(_vm._s(_vm.$t("message.our_service.remark")))
        ]),
        _c("br"),
        _vm._v(" "),
        _c("ul", { staticClass: "maininfo-list" }, [
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("message.our_service.remark01"))
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("img", {
        staticClass: "img-fluid img-center",
        attrs: { src: "/static/img/coverage-bedroom.jpg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("img", {
        staticClass: "img-fluid img-center",
        attrs: { src: "/static/img/coverage-bathroom.jpg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("img", {
        staticClass: "img-fluid img-center",
        attrs: { src: "/static/img/coverage-kitchen.jpg" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9220c5c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9220c5c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Service.vue
// module id = 1456
// module chunks = 0